import { ConversationStatus, hasActiveConversation } from "@/app/api/message";
import { useMessageStore } from "@/app/store";
import { CurrentChatStatus } from "@/app/store/types";

/**
 * 拉取服务端「是否仍在会话中」并同步 chatStatus、imServiceChannel、sessionInfo。
 * 用于 WS 传输层 DISCONNECTED/ERROR/异常关闭码等不确定场景，避免仅凭 socket 状态误判会话结束。
 */
export async function syncImSessionFromActiveConversationApi(): Promise<void> {
  try {
    const sessionInfo = await hasActiveConversation();
    const store = useMessageStore.getState();

    if (!sessionInfo.hasActiveConversation) {
      store.setCurrentChatStatus(CurrentChatStatus.ChatEnd);
      return;
    }

    if (sessionInfo.status === ConversationStatus.LineUp) {
      store.setCurrentChatStatus(CurrentChatStatus.LineUp);
    } else {
      store.setCurrentChatStatus(CurrentChatStatus.Online);
    }
  } catch {
    // 接口失败（如仍完全断网）时不强行改写 chatStatus，保留断线前状态
  }
}
